var _defs, _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVBankSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_4",
    "data-name": "Componente 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.32,
    height: 55.472,
    viewBox: "0 0 51.32 55.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_43",
    "data-name": "Ret\\xE2ngulo 43",
    width: 51.32,
    height: 55.472,
    fill: "#4c4b97"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_39",
    "data-name": "Ret\\xE2ngulo 39",
    width: 4.435,
    height: 7.821,
    fill: "#4c4b97"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17",
    "data-name": "Caminho 17",
    d: "M93.1,267.156l-4-3.306-.439-4.515L92.53,261.3Z",
    transform: "translate(-88.665 -259.335)",
    fill: "#4c4b97"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_41",
    "data-name": "Ret\\xE2ngulo 41",
    width: 4.346,
    height: 7.116,
    fill: "#4c4b97"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_18",
    "data-name": "Caminho 18",
    d: "M98.162,359.127l3.923,2.554.424,4.563-3.865-1.962Z",
    transform: "translate(-98.162 -359.127)",
    fill: "#4c4b97"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_71",
    "data-name": "Grupo 71",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_70",
    "data-name": "Grupo 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_69",
    "data-name": "Grupo 69",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_16",
    "data-name": "Caminho 16",
    d: "M25.132,55.472A14.967,14.967,0,0,1,17.4,53.312a14.318,14.318,0,0,1-6.972-10.949l-.757-7.778L4.649,30.432A12.681,12.681,0,0,1,2.126,13.6a5.119,5.119,0,0,1,5.517-2.13,4.988,4.988,0,0,1,3.876,4.39L13.168,32.8l.073.061a5.426,5.426,0,0,0,4.581,1.13,5.32,5.32,0,0,0,3.723-2.844L34.7,4.673A8.455,8.455,0,0,1,42.3,0h.045a8.458,8.458,0,0,1,7.6,4.6,12.454,12.454,0,0,1,.143,11.116,12.938,12.938,0,0,1-8.819,7.017A4.5,4.5,0,0,0,37.8,28l2.013,9.925A14.623,14.623,0,0,1,30.535,54.47a15.136,15.136,0,0,1-5.4,1M13.591,37.138l.476,4.885a10.778,10.778,0,0,0,5.249,8.242,11.267,11.267,0,0,0,9.89.872,11.064,11.064,0,0,0,7.019-12.52l-2.013-9.925a8.063,8.063,0,0,1,6.206-9.444,9.315,9.315,0,0,0,6.35-5.052,8.967,8.967,0,0,0-.1-8,4.882,4.882,0,0,0-8.672.043L24.835,32.707a8.942,8.942,0,0,1-6.257,4.779,9.18,9.18,0,0,1-4.987-.348M6.394,14.9a1.392,1.392,0,0,0-1.2.653A9.154,9.154,0,0,0,7.012,27.7l2.16,1.788L7.878,16.2a1.409,1.409,0,0,0-1.109-1.256,1.633,1.633,0,0,0-.375-.043",
    transform: "translate(0)",
    fill: "#4c4b97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_63",
    "data-name": "Grupo 63",
    transform: "translate(8.733 24.975)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_62",
    "data-name": "Grupo 62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_61",
    "data-name": "Grupo 61",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_60",
    "data-name": "Grupo 60",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59",
    "data-name": "Grupo 59",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_38",
    "data-name": "Ret\\xE2ngulo 38",
    width: 9.015,
    height: 8.016,
    transform: "matrix(0.536, -0.844, 0.844, 0.536, -3.621, 5.571)",
    fill: "#4c4b97"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_68",
    "data-name": "Grupo 68",
    transform: "translate(9.668 34.585)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67",
    "data-name": "Grupo 67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_66",
    "data-name": "Grupo 66",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65",
    "data-name": "Grupo 65",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_64",
    "data-name": "Grupo 64",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_40",
    "data-name": "Ret\\xE2ngulo 40",
    width: 8.27,
    height: 8.013,
    transform: "translate(-3.604 4.049) rotate(-48.965)",
    fill: "#4c4b97"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVBankSmallLogo);
export default __webpack_public_path__ + "static/media/vBankSmallLogo.66c71e0c45410a89bfa7e18737ea751a.svg";
export { ForwardRef as ReactComponent };